import { render } from "./RedirectToCompanyCoursesAction.vue?vue&type=template&id=534c7110"
import script from "./RedirectToCompanyCoursesAction.vue?vue&type=script&lang=js"
export * from "./RedirectToCompanyCoursesAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__